import { Phone, Mail, MapPin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { CONTACT } from "../data/pricing";

export const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();
  return (
    <footer id="contatti" data-testid="footer-section" className="relative pt-20 pb-8 border-t border-slate-500/15 bg-[#04070F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img src="/logo.png" alt="Cosimiroclean" className="h-12 w-auto" />
            </div>
            <p className="text-sm text-slate-400 mt-4 leading-relaxed">
              Detailing e pulizia auto di alta qualità. Il tuo abitacolo come
              nuovo, con prodotti professionali e risultati garantiti.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer"
                data-testid="social-instagram"
                className="w-10 h-10 rounded-full glass flex items-center justify-center text-slate-300 hover:text-[#A0E0FF] hover:border-[#7EC8E3]/50 transition-colors">
                <Instagram size={18} />
              </a>
              <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer"
                data-testid="social-facebook"
                className="w-10 h-10 rounded-full glass flex items-center justify-center text-slate-300 hover:text-[#A0E0FF] hover:border-[#7EC8E3]/50 transition-colors">
                <Facebook size={18} />
              </a>
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer"
                data-testid="whatsapp-direct-btn"
                className="w-10 h-10 rounded-full glass flex items-center justify-center text-slate-300 hover:text-[#A0E0FF] hover:border-[#7EC8E3]/50 transition-colors">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>

          {/* Contatti */}
          <div>
            <h4 className="font-display font-bold text-slate-100 mb-4">Contatti</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone"
                  className="flex items-center gap-3 hover:text-[#A0E0FF] transition-colors">
                  <Phone size={16} className="text-[#7EC8E3]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email"
                  className="flex items-center gap-3 hover:text-[#A0E0FF] transition-colors">
                  <Mail size={16} className="text-[#7EC8E3]" /> {CONTACT.email}
                </a>
              </li>
              <li data-testid="footer-address" className="flex items-center gap-3">
                <MapPin size={16} className="text-[#7EC8E3]" /> {CONTACT.area}
              </li>
            </ul>
          </div>

          {/* Menu */}
          <div>
            <h4 className="font-display font-bold text-slate-100 mb-4">Menu</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              {[
                { id: "hero", label: "Home" },
                { id: "servizi", label: "Servizi" },
                { id: "prenota", label: "Prenota" },
                { id: "aziende", label: "Aziende e flotte" },
                { id: "perche-noi", label: "Perché sceglierci" },
                { id: "recensioni", label: "Recensioni" },
              ].map((l) => (
                <li key={l.label}>
                  <button onClick={() => onNavigate(l.id)} className="hover:text-[#A0E0FF] transition-colors">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="font-display font-bold text-slate-100 mb-4">Pronto a partire?</h4>
            <p className="text-sm text-slate-400 mb-4">
              Prenota ora e riscopri la tua auto come appena uscita dal
              concessionario.
            </p>
            <button onClick={() => onNavigate("prenota")}
              className="btn-silver rounded-full px-6 py-3 text-sm">
              Prenota il tuo servizio
            </button>
          </div>
        </div>

        <div className="metallic-divider my-8" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {year} Cosimiroclean – Detailing Auto. Tutti i diritti riservati.</span>
          <div className="flex items-center gap-4">
            <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#A0E0FF] transition-colors">
              Area riservata
            </a>
            <span className="tracking-[0.2em]">DETAILING AUTO</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
